export default "__VITE_ASSET__02IOVPSN__"